import { getCss, buildResponsiveStyles, buildResponsiveTextStyles, mergeDeep, color as colorUtils, } from "../../utils";
export const createStyles = (tag, variant, color, align, weight) => {
    const styles = getCss({
        '@global': {
            ':host': {
                // if default tag is displayed as block use display: block
                display: 'block',
            },
            [tag]: Object.assign({ display: 'inline-block', fontFamily: 'Bosch Sans', textDecoration: 'inherit', margin: '0' }, mergeDeep(buildResponsiveTextStyles(variant), buildResponsiveStyles(color, (colorResponsive) => ({
                color: colorResponsive === 'inherit' ? 'inherit' : colorUtils[colorResponsive],
            })), buildResponsiveStyles(align, (alignResponsive) => ({
                textAlign: alignResponsive,
            })), weight
                ? buildResponsiveStyles(weight, (weightResponsive) => ({
                    fontWeight: weightResponsive,
                }))
                : {})),
        },
    });
    return styles;
};
//# sourceMappingURL=text-styles.js.map
